export const isImageMimeType = (mimeType: string | undefined) =>
	(mimeType ?? "").startsWith("image/");
